<template>
    <div>
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header p-2">
                        <h6 class="modal-title">{{$t('Edit Stop Words')}}</h6>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" v-on:click="closeDialog()">
                            <span aria-hidden="true">
                                <cancel-icon class="close-icon" style="height: 30px !important;width: 30px !important;color: #fff;"></cancel-icon>
                            </span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="search-input-container">
                            <input  type="text" class="rounded text-light search-bar"  :placeholder="$t('Search word')"   autocomplete="off" v-model="search" @input="displayFilteredTags(false)"/>
                            <cancel-icon v-if="search" class="clear-search-icon" @click.native="search = ''; displayFilteredTags(false)"></cancel-icon>
                            <button class="btn btn-outline-primary" style="width: 87px !important;margin-left:1rem !important;height: 40px;float: right;" @click="addStopWord()" > {{$t('Add Word')}}</button>
                        </div>
                        <div class="add-word-container" v-if="showAddWordInput">
                            <input  v-model="newStopWord" ref="newWordsInput" type="text"  class="add-word-input" :placeholder="$t('Enter stop words separated by comma(,)')" @keyup.enter="confirmAddWord" />
                            <button class="btn btn-outline-primary ml-2" @click="confirmAddWord" >  {{$t('Add')}}  </button>
                            <button class="btn btn-outline-secondary ml-2" @click="cancelAddWord" >  {{$t('Cancel ')}}</button>
                        </div>
                        <div class="d-inline-flex" style="flex-wrap: wrap;overflow: auto;height: 325px;align-content: flex-start;width: 100%;">
                            <!-- No stop words -->
                            <div v-if="!editedStopWords ||   editedStopWords.length === 0"  class="empty-field-text-styles" >
                                {{$t('No stop words found')}}
                            </div>

                            <div v-else-if="filteredStopWords && filteredStopWords.length > 0" v-for="word in filteredStopWords" :key="word" class="search-in-filter-styles">
                                <span class="stop-word-text">  {{ word }}  </span>
                                <cancel-icon @click.native="removeStopWord(word)" class="delete-word" ></cancel-icon>
                            </div>

                            <div v-else class="empty-field-text-styles" >
                                {{$t('No matching stop words found')}}
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer p-0 primary-btn-style" style="margin-top:0px !important">
                        <div>
                        </div>
                        <div>
                            <button class="btn btn-outline-secondary mr-3" data-dismiss="modal" @click="closeDialog()">{{$t('Cancel')}}</button>
                            <button class="btn btn-outline-primary mr-3" @click="saveChanges()">{{$t('Save')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <CustomMessage v-if="showConfirmDialog" v-bind="alertMessageProperties" @close="forceCloseDialog()" @allowUpdation="discardStopWordChanges()" @allowDeletion="saveChanges()"></CustomMessage>
    </div>
</template>
    
<script>
    import cancelIcon from "../core/InlineCancelField.vue"
    import CustomMessage from "../actions/customAlertMessage.vue";
    export default {
        props:["stopwords"],
        data(){
            return{
                selectedCatalog:null,
                selectedCatalogsArr:[],
                applyRecursively:false,
                browsedFolderPath: null,
                selectedCatParentIdList:[],
                editedStopWords:[],
                filteredStopWords:[],
                showAddWordInput: false,
                newStopWord: '',
                showConfirmDialog:false,
                search:''
            };
        },
        components:{
            'cancel-icon':cancelIcon,
            CustomMessage
        },
        computed:{
            alertMessageProperties(){
                return {
                    "messageTitle":this.$t("Unsaved Changes"),
                    "messageType": "",
                    "displayMessage":`${this.$t("You have made changes to the stopwords list. Do you want to save these changes?")}.`,
                    "getUserConfirmation":true,
                    "deleteButtonText": this.$t('Save')
                }
            },
        },
        methods:{
            displayFilteredTags() {
                const searchText = this.search.trim().toLowerCase();

                if (!searchText) {
                    this.filteredStopWords = [...this.editedStopWords];
                    return;
                }

                this.filteredStopWords = this.editedStopWords.filter(word =>
                    word.toLowerCase().includes(searchText)
                );
            },
            confirmAddWord() {
                const words = this.newStopWord
                    .split(',')
                    .map(word => word.trim())
                    .filter(word => word);

                if (!words.length) {
                    return;
                }

                // Avoid duplicate words
                const uniqueWords = words.filter(
                    (word, index, self) =>
                        self.indexOf(word) === index &&
                        !this.editedStopWords.includes(word)
                );

                if (!uniqueWords.length) {
                    return;
                }

                // Add all new words at the beginning
                this.editedStopWords.unshift(...uniqueWords);
                this.displayFilteredTags();

                this.newStopWord = '';
                this.showAddWordInput = false;
            },
            cancelAddWord() {
                this.newStopWord = '';
                this.showAddWordInput = false;
            },
            addStopWord() {
                this.showAddWordInput = true;
                this.newStopWord= '';
                this.$nextTick(() => {
                    this.$refs.newWordsInput.focus();
                });
            },
            hasStopWordsChanged() {
                if (this.stopwords.length !== this.editedStopWords.length) {
                    return true;
                }

                const original = [...this.stopwords].sort();
                const edited = [...this.editedStopWords].sort();

                return original.some((value, index) => value !== edited[index]);
            },
            discardStopWordChanges() {
                this.editedStopWords = [...this.stopwords];
                this.showConfirmDialog = false;
                this.$emit("closeDialog");
            },
            closeDialog(){
                if (this.hasStopWordsChanged()) {
                    // show confirmation
                    this.showConfirmDialog = true;
                    return;
                }

                this.$emit("closeDialog");
            },
            forceCloseDialog(){
                this.showConfirmDialog=false;
                this.$emit("closeDialog");
            },
            saveChanges(){
                const stopWords = this.editedStopWords
                        .map(word => word.trim())
                        .filter(word => word.length > 0);

                this.showConfirmDialog = false;
                this.$emit("saveChanges", stopWords);
            },
            removeStopWord(word) {
                this.editedStopWords = this.editedStopWords.filter(item => item !== word);
                this.displayFilteredTags();
            },
        },
        created(){
            if(this.stopwords){
                this.editedStopWords = [...this.stopwords];
                this.filteredStopWords = [...this.editedStopWords];
            }
        },
    }
</script>
    
<style scoped lang="scss">
    $table-row-border: none;
    $active-blue: #007bff;
    $danger-color: #dc3545;
    $none-text-color:#4f4f4f;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;
    $active-green-color:#28a745;
    $primary-background: #1a1e21;
    $border-color: 1px solid #4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $highlight-font-color:#ff9800;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555; 
    $input-field-padding:.375rem 10px;
    $filter-border-color: #5a5a5a;
    $filter-bg-color: #2a2a2a;
    $learn-about-text-color-hover:#b7b327;
    $learn-about-text-color:#9a9620;
    $tags-background-color:#282d31;
    $svg-color:#666;
    $tags-border-color:#363636;
    $secondary-border-color: 1px solid #2b2b2b;
    $icon-hover:#2c3339;
    
    
    .config-desc{
        color: $dull-text-color;
    }
    .input-text-field{
        height: 44px;
        width: 100% !important;
        padding-inline-start: 2%;
        padding-inline-end:2%;
        overflow: hidden;
    }

    .modal-dialog {
        max-width: 500px !important;
        width: 500px !important;
        // height: 60% !important;
        margin: 0;
        padding: 0;
    }
  
    .modal-content {
        height: auto !important;
        max-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        background: $primary-background !important;
        border: $secondary-border-color;
        .modal-body{
            background: $primary-background;
            max-height: 450px;
            padding: 1rem !important;
            display: grid;
        }
    }

    .modal {
        text-align: center;
        padding: 0 !important;
        display: inline-flex;
        position: fixed;
        align-items: center;
        justify-content: center;
        
    }
    .modal:before {
        content: "";
        display: inline-block;
        height: 100vh;
        vertical-align: middle;
        margin-inline-end: -4px;
        position: fixed;
        width: 100vw;
        inset-inline-start: 0;
        top: 0;
        background: #00000094;
    }
    .modal-dialog {
        display: inline-block;
        text-align: start;
        vertical-align: middle;
    }
    
    .btn{
        font-size:14px !important;
        height:100%;
    }
    
    .search-bar{
        background: $primary-background!important;
        height:40px;
        width: 250px !important;
        float: inline-start;
        padding-inline-start: 12px;
        padding-bottom: 2px;
        border:$border-color !important;
        margin-bottom: 15px;
    }
    
    .height-set{
        height: calc(100vh - 170px);
        background: $primary-background;
        .group-name{
            text-align: start;
            padding:16px 3%;
            font-size:27px;
            display:flex;
        }
        .group-members{
            height: calc(100% - 90px);
            cursor: pointer;
        }
    }
    
    
    .editIcon {
        margin-inline-start: 9px;
        margin-top: 0px
    }
    
    .comm-input-field-style{
        background: $primary-background!important;
        height:40px;
        width: 100% !important;
        float: inline-start;
        padding-inline-start: 12px;
        padding-bottom: 2px;
        border: $border-color!important;
    }
    
    .search-bar-comm-style{
        height:60px;
    }
    
    #contact_number_input::-webkit-outer-spin-button,
    #contact_number_input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    
    .close-icon:hover{
        background: #373737;
        border-radius: 20px;
    }
    
    .key-div {
        text-align: end;
        color: $dull-text-color;
    }
    .value-div {
        text-align: start;
        margin-inline-start: 7px;
        width: 100%;
        font-weight: 500;
        input,select{
          padding-inline-start:4px;
        }
    }
    
    
    .activeclass {
        color: $active-blue;
    }
    
    table {
        background: transparent;
        thead {
            th {
                color: $dull-text-color;
                border-top: none !important;
                border-bottom: none !important;
            }
        }
        tbody {
            color: $text-color;
            td {
                border-top: none !important;
            }
        }
    }
    
    .btn {
        font-size: $input-field-and-label-font-size !important;
        height: 100%;
    }
    
    .custom-control-label::before {
        background-color: $primary-background;
    }
    
    table.users-basic-info-table .editIcon {
        visibility: hidden;
    }
    table.users-basic-info-table td.value-div:hover .editIcon {
        visibility: visible;
    }
    
    .disablefield {
        border: none !important;
        pointer-events: none;
    }
    
    .force-logout {
        position: relative;
        inset-inline-start: 5px;
        bottom: 4px;
    }
    .force-logout:hover {
        text-decoration: underline;
    }
    .activestatus {
        color: $active-green-color !important;
    }
    .validationmessage {
        color: $danger-color;
        font-size: 11px;
    }
    
    .nav-item{
        color: $dull-text-color !important;
    }
    
    .active{
        background: $primary-background !important;
        color: $text-color !important;
    }
    .top-nav-bar{
        background: $primary-background;
    }
    
    .tags-display-ul .show-tags-delete{
        visibility:hidden;
    }
    
    .tags-display-ul li:hover .show-tags-delete{
        visibility: visible;
    }
    
    .editIcon{
        visibility:hidden;
    }
    
    .group-name:hover .editIcon{
        visibility: visible;
    }
    
    .show-tags-delete{
        position: relative;
        top: 2px;
    }
    
    .breadcrumb{
        padding: .75rem 1rem !important;
        background: $primary-background !important;
        .active-text-nav-bar{
            color: $text-color !important;
            text-decoration: none !important
        }
        .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
        }
        .breadcrumb-item{
            a{
                color: $text-color;
                font-weight:600;
            }
            a:hover{
                text-decoration: underline;
            }
        }    
    }
    
    .delete-user-icon{
        visibility: hidden;
    }
    
    .comm-tags-class:hover .delete-user-icon{
        visibility: visible;
    }
    
    /* width */
    ::-webkit-scrollbar {
        width: 8px;
    }
    
    /* Track */
    ::-webkit-scrollbar-track {
        background: $scrollbar-track-background;
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $scrollbar-thumb-background;
    }
    
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $scrollbar-thumb-on-hover-background;
    }
    .border{
        border: $border-color !important;
    }
    
    .activePool{
        color: $active-blue;
    }
    
    .modal-header,.modal-footer{
        border-top: $secondary-border-color !important;
        border-bottom: $secondary-border-color !important;
        background: $secondary-background-color;
        .modal-title{
            color:$text-color;
        }
    }
    
    .modal-header .close {
        margin: 0px !important;
        padding: 0px !important;
    }
    
    ul{
        list-style-type: none;
    }
    
    .primary-btn-style {
        margin-top: 1%;
        height:55px;
        button {
            height: 35px;
            width: 70px;
            border-radius: 5px;
            font-size:14px;
        }
    }
    
    .search-bar-comm-style{
        height:30px;
        position:relative;
        input{
            border:$border-color;
            height: 25px;
            padding-inline-start: 6%;
        }
        svg{
            position: absolute;
            inset-inline-start: 21px;
            top: 58%;
        }
    }
    
    .secondary-btn-style{
        color:$text-color;
    }
    
    .modal-footer{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    
    .view-tags {
        font-size:12px!important;
        height: 30px!important;
        display: inline-flex!important;
        margin: 2px!important;
        border: 1px solid $tags-border-color!important;
        border-radius: 15px!important;
        min-width: 50px!important;
        padding: 0!important;
        text-align: center;
        width: auto!important;
        padding-inline-start: 1px!important;
        justify-content: center;
        padding-top: 4px!important;
        background: $tags-background-color;
        span {
            padding: 0px 8px !important;
            margin-inline-start: 0px !important;
            font-size:12px !important;
            border-radius: 15px !important;
            position: relative !important;
            top: 1px !important;
        }
    }
    
    .secondary-btn-style:hover{
        text-decoration: underline;
    }
    
    .close-icon:hover{
        background: $icon-hover;
        border-radius: 20px;
    }
    
    .search-bar-comm-style{
        text-align: center;
        height:auto;
        .search-bar{
            background: $primary-background!important;
            height:42px;
            //width: 180px !important;
            //float: inline-start;
            width:94% !important;
            padding: 0px 12px 0 8px;
            padding-inline-start: 12px;
            border:$border-color !important;
        }
    }

    .search-in-filter-styles{
        position: relative;
        display: inline-flex;
        align-items: flex-start;
        justify-content: center;

        padding: 2px 28px 2px 8px;
        margin-inline-end: 5px;
        margin-bottom: 5px;
        height: 30px;
        box-sizing: border-box;

        background-color: #1a1e21 !important;
        border: 1px solid #4a4a4a;
        border-radius: 5px;

        font-size: 14px;
        cursor: default;

        overflow: hidden;
    }
    .stop-word-text {
        text-align: center;
        white-space: normal;
        overflow-wrap: anywhere;
        word-break: break-word;
        line-height: 20px;
    }
    .empty-field-text-styles{
        color:$none-text-color;
        width: 100%;
        height: 325px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
    }
    .search-input-container {
        position: relative;
    }
    .search-input-container .search-bar {
        width: 100%;
        padding-right: 35px;
    }

    .clear-search-icon {
        position: absolute;
        right: 214px;
        top: 40%;
        transform: translateY(-50%);
        cursor: pointer;
    }

    .delete-word{
        position: absolute;
        right: 1px;
        top: 50%;
        transform: translateY(-50%);

        opacity: 0;
        visibility: hidden;

        transition: opacity 0.1s ease;
    }
    .delete-word:hover{
        color: #eee;
    }
    .search-in-filter-styles:hover{
        background: #373737 !important;
        justify-content: flex-start;
        .stop-word-text{
            text-align: left;
        }
        .delete-word{
            opacity: 1;
            visibility: visible;
        }
    }
    .add-word-container {
        display: flex;
        align-items: center;
        margin-bottom: 13px;
    }

    .add-word-input {
        width: 298px;
        height: 35px;
        padding: 5px 10px;
        color: $text-color;
        background: $primary-background;
        border: $border-color;
        border-radius: 4px;
        outline: none;
    }

    .add-word-input:focus {
        border-color: $active-blue;
    }
    
</style>